module.exports = __webpack_public_path__ + "img/benefits-placeholder.6b8d8a1a.png";